<template>
  <div class="tb-right-section">
    <div class="tb-show-column">
      <h4>columns:</h4>
    </div>
    <div class="tb-select-column-dropdown">
      <v-select
        v-model="selectedColumns"
        :items="allColumns"
        item-text="title"
        item-value="field"
        label="Select columns"
        multiple
        @change="applyColumnSelection"
        dense
        solo
      >
      <template v-slot:selection="{ item, index }">
        <v-chip v-if="index <= 1" x-small>
          <span>{{ item.title }}</span>
        </v-chip>
        <span
          v-if="index === 2"
          class="grey--text text-caption"
        >
          (+{{ selectedColumns.length - 1 }} others)
        </span>
      </template>
    </v-select>
    </div>

    <div>
      <v-btn class="tb-clear-btn" @click="showAllColumns" text
        >Clear</v-btn
      >
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Api from "@/objects/api";
import {
  readColumnCondition,
  toColumnKeys,
} from "./breadDataTable/columnCondition";
export default {
  name: "BreadTabulatorSelectColumn",
  computed: mapState({
    auth: (state) => state.auth.data,
    services: (state) => state.service.data.services,
  }),

  data: () => ({
    allColumns: [],
    selectedColumns: [],
    isPrivate: false,
    ownerUuid: "",
    defaultColumns: [],

    api: new Api(),
  }),
  props: {
    model: {
      type: Object,
      required: true,
    },
  },

  created() {
    this.allColumns = this.$_.filter(
      this.model.browse.table.headers,
      (columns) => {
        if (columns.selectableColumn == true  ) {
          return columns;
        }
      }
    );

    // `visible: false` must exclude a column from the default set too — it is
    // the other way a model says "off by default" (e.g. Revert Form Status,
    // Manual Invoice Ready). Checking only showByDefault let those leak in.
    this.defaultColumns = this.$_.filter(
      this.model.browse.table.headers,
      (columns) => {
        if (
          columns.selectableColumn == true &&
          columns.showByDefault != false &&
          columns.visible != false
        ) {
          return columns;
        }
      }
    );
  },

  watch: {
    
  },

  mounted() {
    // The <v-select> is item-value="field", so its v-model is a STRING array.
    // This used to assign column OBJECTS, which then (a) failed the
    // `includes(col.field)` check downstream — hiding every column and
    // rendering a blank table — and (b) got JSON.stringify'd into
    // CrmView.cColumnCondition, permanently polluting saved views with two
    // incompatible shapes. Always emit field strings. See columnCondition.js.
    // Start from the model's DEFAULT set, not every selectable column — the
    // initial state must match what the table actually renders before a view
    // is applied.
    this.selectedColumns = this.$_.map(this.defaultColumns, "field");
  },

  methods: {
    applyColumnSelection() {
      this.$emit("applyColumnSelection", toColumnKeys(this.selectedColumns));
    },

    showAllColumns() {
      this.selectedColumns = this.$_.map(this.defaultColumns, "field");
      this.$emit("applyColumnSelection", this.selectedColumns);
    },

    showViewSelectedColumns(viewColumns) {
      // Stored views hold either shape; normalise on read. A null result means
      // "no stored preference", so fall back to the model's defaults rather
      // than hiding everything (17 live views store an empty array).
      const keys = readColumnCondition(viewColumns, this.allColumns);
      if (!keys) {
        this.showAllColumns();
        return;
      }
      this.selectedColumns = keys;
      this.$emit("applyColumnSelection", this.selectedColumns);
    },
  },
};
</script>
